<template lang="pug">
div
  .note_text(v-if="lang === '泰语'" style='background: #fff; padding: 10px; font-size: 16px; line-height: 1.6em; color: #333;')
    | ผลการใช้งานจริงของผลิตภัณฑ์นี้จะขึ้นอยู่กับสถานการณ์ของแต่ละบุคคลในการตัดสินใจไม่รับประกันว่าผู้ใช้ทุกคนสามารถเพลิดเพลินกับผลของการโฆษณา ถ้าคุณมีคำถามใดๆโปรดปรึกษาตัวแทนออนไลน์ผ่านทาง dpcocoservice@outlook.com หรือติดต่อเราบริษัทย่อมมีสิทธิที่จะอธิบาย
    br
    | เกี่ยวกับเวลาการส่งมอบ
    br
    | สั่งซื้อสินค้าหลังจากความสำเร็จเราก็จะเป็นไปตามลำดับการกระจาย , การกระจายเป็นระยะเวลาประมาณ 3 วันมักจะมาถึงในเวลาประมาณ 7 วัน
    br
    | วิธีการสมัครสำหรับการคืนสินค้า
    br
    | คุณภาพ 1 เนื่องจากสาเหตุการคืนสินค้า : จนถึงวันที่ได้รับสินค้า 7 วันส่งเมล์ให้กับศูนย์บริการหลังการขาย - ลูกค้าจะได้รับหลังจากที่ส่ง 1-3 วันได้รับการยอมรับการร้องขอของคุณและการคืนสินค้าที่ผลิตที่ค่าใช้จ่ายของเรา
    br
    | 2 การคืนสินค้าในขั้นตอน :
    br
    | เพื่อยืนยันการรับ - สมัคร - ผ่านการตรวจสอบการคืนสินค้าของลูกค้าผู้ใช้สินค้า - ทางไปรษณีย์ - ฝ่ายคลังสินค้า - การตรวจสอบการตรวจสอบการคืนสินค้า / เปลี่ยนสินค้า - คืนเงิน
    br
    | การคืนสินค้ากรุณาระบุหมายเลขใบสั่งซื้อ , ชื่อ , โทรศัพท์
    br
    | วิธีการยกเลิกการสั่งซื้อ
    br
    | ยกเลิกใบสั่งซื้อให้กับศูนย์บริการอีเมลที่ส่งและระบุสาเหตุเกี่ยวข้องกับเนื้อหาของข้อความที่คุณจะระบุเลขที่ใบสั่งซื้อ , ชื่อ , โทรศัพท์

  .note_text(v-if="lang === '英语'" style='background: #fff; padding: 10px; font-size: 16px; line-height: 1.6em; color: #333;')
    | The actual use of this product depends on the individual situation, not guaranteeing that every user can enjoy the publicity effect. If you have any questions, please consult online customer service or contact us via e-mail. Our company has the right of final explanation.
    br
    | · When the delivery time
    br
    | orders are successful, we will arrange the goods according to the order order order. The delivery period is about 3 working days, and the arrival time is about 7 working days.
    br
    | · How to apply for return and exchange
    br
    | 1. Return and exchange due to quality reasons: within 7 days from the date of receipt of goods, send mail to dpcocoservice@outlook.com to after-sales service center, customer service will accept your request within 1-3 working days after receipt of mail, and the freight caused by return and exchange shall be borne by us.
    br
    | 2. Return and exchange process:
    br
    | confirm receipt-apply for return and exchange-customer service approval-user send back goods-warehouse sign-check-return and exchange-refund/exchange process;
    br
    | return and exchange goods please indicate: order number, name, telephone.
    br
    | · How to cancel the order
    br
    | Cancel the order needs to send an email to the after-sales service center and indicate the relevant reasons. The content of the email should indicate your order number, name and telephone number.
  .note_text(v-if="lang === '繁体中文'" style='background: #fff; padding: 10px; font-size: 16px; line-height: 1.6em; color: #333;')
    | 本產品的實際使用效果根據個人情況決定，不保證每位用戶都能享受到所宣傳的效果。若有疑問請諮詢在線客服或通過電子郵箱聯絡我們，本公司享有最終解釋權。
    br
    | ·關於配送時間
    br
    | 下單成功之後，我們會按照下單先後順序進行配貨，配貨週期為3個工作日左右，一般到達時間為7個工作日左右。
    br
    | ·如何申請退換貨
    br
    | 1.退貨說明：
    br
    | （1）由於個人原因產生的退換貨：至收到商品之日起7天內，在不影響二次銷售的情況下請聯繫我們的在線客服或發郵件至dpcocoservice@outlook.com ，售後客服會在收到消息後的1-3個工作日內受理您的請求，退換貨所產生的運費需自行承擔。 （2）由於質量原因產生的退換貨：至收到商品之日起7天內，向售後服務中心發送郵件dpcocoservice@outlook.com，客服會在收到郵件後的1-3個工作日內受理您的請求，退換貨所產生的運費由我方承擔。
    br
    | 2.退換貨流程:
    br
    | 確認收貨—申請退換貨—客服審核通過—用戶寄回商品—倉庫簽收驗貨—退換貨審核—退款/換貨；
    br
    | 退換貨請註明：訂單號、姓名、電話。
    br
    | ·如何取消訂單
    br
    | 取消訂單需要向售後服務中心發送郵件并注明相关原因，邮件内容应註明您的訂單號、姓名、電話。
</template>

<script>
export default {
  props: ['lang']
}
</script>